export default function flattenMapOfArrayToArray<K,V>(
  map: Map<K, Array<V>>,
): Array<V> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return Array.from(map).flatMap(([_, arr]) => arr)
}